'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var bumbag = require('bumbag');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var StatusText = function StatusText(_ref) {
  var description = _ref.description,
      statusTextClass = _ref.statusTextClass,
      statusIcon = _ref.statusIcon;
  return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    color: statusTextClass,
    fontWeight: "semibold"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
    fontSize: "150"
  }, /*#__PURE__*/React__default["default"].createElement("i", {
    className: statusIcon + " margin-right-5 has-text-" + statusTextClass
  }), description));
};

exports["default"] = StatusText;
